import React from 'react';
import Box from '-/style/base/Box';
import Subhead from '-/style/base/Subhead';
import { GET_COMPANY_MONDAY_REPORT_ACTIVE } from '-/gql/company';
import { graphql } from 'react-apollo';
import { get } from 'lodash';
import StandardTable from './StandardTable';
import LoadingLogo from '-/components/LoadingLogo';
import { ActiveRow } from './StandardRow';
import { ActiveHeader } from './StandardHeader';

const Active = props => {
    const { data = {} } = props;
    const { loading } = data;
    const companies = get(data, 'CompanyMondayReport.active', []);
    if (loading) {
        return <LoadingLogo />;
    }
    return (
        <Box>
            <Subhead>Active</Subhead>
            <StandardTable
                data={companies}
                Row={ActiveRow}
                Header={ActiveHeader}
            />
        </Box>
    );
};

export default graphql(GET_COMPANY_MONDAY_REPORT_ACTIVE)(Active);
